import type { IconSvgObject } from './types';

const ReloadIcon: IconSvgObject = [
  ["path", { d: "M15 2L16 4.54815C14.8079 3.91117 13.4461 3.55005 12 3.55005C7.30558 3.55005 3.5 7.35563 3.5 12.05C3.5 13.8412 4.054 15.6297 5 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 22L8 19.4518C9.19215 20.0888 10.5539 20.4499 12 20.4499C16.6944 20.4499 20.5 16.6443 20.5 11.9499C20.5 10.1588 19.946 8.37034 19 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ReloadIcon;
